import { FormEvent, useState } from "react";
import { useWidgetStore } from "../../store/widget-store";
import { getWidgetKey } from "../../lib/widget-key";

type MessageInputProps = {
  externalCustomerId: string;
};

export function MessageInput({ externalCustomerId }: MessageInputProps) {
  const [value, setValue] = useState("");
  const isSending = useWidgetStore((state) => state.isSending);
  const sendMessage = useWidgetStore((state) => state.sendMessage);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    const publicKey = getWidgetKey();
    if (!publicKey || !value.trim()) return;

    const body = value;
    setValue("");
    await sendMessage(publicKey, externalCustomerId, body);
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2 border-t border-gray-200 p-3">
      <input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder="Type a message…"
        className="flex-1 rounded-full border border-gray-200 px-4 py-2 text-sm outline-none focus:border-brand"
      />
      <button
        type="submit"
        disabled={isSending || !value.trim()}
        className="rounded-full bg-brand px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
      >
        Send
      </button>
    </form>
  );
}
